import React from "react";

const LoaderSkeleton = () => {
    return (
        <div className="px-4">
            <div
                className=" d-flex align-items-center justify-content-center"
                style={{ height: "70vh" }}
            >
                <div
                    className="spinner-border h3"
                    style={{ width: 80, height: 80 }}
                    role="status"
                />
            </div>
        </div>
    );
};

export default LoaderSkeleton;
